'use strict';

var batcher = require('./batcher.cjs');

const { schedule: microtask, cancel: cancelMicrotask } = 
/* @__PURE__ */ batcher.createRenderBatcher(queueMicrotask, false);

exports.cancelMicrotask = cancelMicrotask;
exports.microtask = microtask;
//# sourceMappingURL=microtask.cjs.map
